import { Clickable } from '@moda/om';
import React from 'react';
import { useParams } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import { Swiper } from '../../../../components/Swiper';
import { DesktopLookviewPageFragment } from '../../../../generated/types';
import { Image } from '../../../../components/Image';

import './DesktopLookviewPageLooksCarousel.scss';

interface Props {
  looks: DesktopLookviewPageFragment[];
  handleLookClick: (lookId: string) => void;
}

export const DesktopLookviewPageLooksCarousel: React.FC<Props> = ({ looks, handleLookClick }) => {
  const { lookId } = useParams<{
    lookId: string;
  }>();

  return (
    <>
      <Swiper
        className="DesktopLookviewPageLooksCarousel__carousel"
        slidesPerView={5.35}
        spaceBetween={8}
        initialSlide={looks.findIndex(({ id }) => id === lookId)}
        centerInsufficientSlides
        scrollbar={{
          el: `.DesktopLookviewPageLooksCarousel__scrollbar`,
          draggable: true,
          dragClass: `DesktopLookviewPageLooksCarousel__scrollbar-drag`
        }}
      >
        {looks.map(look => (
          <SwiperSlide className="DesktopLookviewPageLooksCarousel__slide" key={look.id}>
            <Clickable
              className="DesktopLookviewPageLooksCarousel__slide"
              onClick={() => handleLookClick(look.id)}
            >
              {look.id === lookId && (
                <span className="DesktopLookviewPageLooksCarousel__selected-slide-indicator" />
              )}

              <Image
                className={classNames(`DesktopLookviewPageLooksCarousel__slide-image`, {
                  [`DesktopLookviewPageLooksCarousel__slide-image--active`]: look.id === lookId
                })}
                src={look.primaryImageUrls?.mediumLow || '://0'}
                alt={look.name || 'Look'}
                width="180"
                height="320"
                lazyload={false}
              />
            </Clickable>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="DesktopLookviewPageLooksCarousel__scrollbar" />
    </>
  );
};
